import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { connect } from 'react-redux';
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi'

import Logout from '../../Common/Logout';
import Switch from '../../../components/Common/Switch';
import Link from '../../Link';
import HeaderModal from '../../HeaderModal/HeaderModal';

import shopUserActivityChange from '../../../actions/shop/userAccount/shopUserActivityChange';
import { shopLogout } from '../../../actions/shop/logout/shopLogout';
import { openHeaderModal } from '../../../actions/siteadmin/modalActions';
import messages from '../../../locale/messages';
import history from '../../../history';
import { formatLocale } from '../../../helpers/formatLocale';

import dashboardIcon from '../../../../public/RestaurantIcon/dashboard.svg';
import editIcon from '../../../../public/RestaurantIcon/editProfile.svg';
import addPayIcon from '../../../../public/RestaurantIcon/payout.svg';
import preparationTimeIcon from '../../../../public/RestaurantIcon/preparationTim.svg';
import operationHoursIcon from '../../../../public/RestaurantIcon/opertaionHours.svg';
import passwordIcon from '../../../../public/RestaurantIcon/pswd.svg';
import CategoryIcon from '../../../../public/RestaurantIcon/managemenuwhiteicon.svg';
import DocumentUpIcon from '../../../../public/RestaurantIcon/docUpload.svg';
import LogOutIcon from '../../../../public/RestaurantIcon/logout.svg';
import TransactionManageIcon from '../../../../public/RestaurantIcon/transactionManagement.svg';
import OrderManageIcon from '../../../../public/RestaurantIcon/orderManagement.svg';
import languageIcon from '../../../../public/Icons/Language-white.svg';

import s from './RestaurantSideMenu.css';
import rs from '../../restaurantCommon.css';

class RestaurantSideMenu extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpen: 0,
			location: '',
			isProfileMenu: false,
			activeMenus: {
				profile: ['/restaurant/edit-profile', '/restaurant/document', '/restaurant/password'],
				order: [
					'/restaurant/order-management/previous', '/restaurant/order-management/upcoming',
					'/restaurant/order-details/previous/', '/restaurant/order-details/upcoming/'],
				transaction: [
					'/restaurant/transaction/completed', '/restaurant/transaction/future',
					'/restaurant/order-details/completed/', '/restaurant/order-details/future/']
			}
		};

		this.openMenu = this.openMenu.bind(this);
		this.closeMenu = this.closeMenu.bind(this);
		this.handleSwitch = this.handleSwitch.bind(this);
		this.handleMenuActive = this.handleMenuActive.bind(this);
		this.renderSinglePageMenu = this.renderSinglePageMenu.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		const { activeMenus: { profile } } = this.state;
		let location = history && history.location && history.location.pathname;

		this.setState({ location });

		if (location && profile && profile.includes(location)) {
			this.setState({ isProfileMenu: true });
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { location } = this.props;
		const { activeMenus: { profile } } = this.state;

		if (prevState.location !== location) {
			this.setState({ location });

			if (location && profile && profile.includes(location)) {
				this.setState({ isProfileMenu: true });
			}
		}
	}

	handleMenuActive(menu) {
		const { activeMenus, location } = this.state;
		if (menu && location && activeMenus[menu] && activeMenus[menu].findIndex(o => location.includes(o)) >= 0) {
			return true;
		} else {
			return false;
		}
	}

	async handleSwitch(status) {
		const { shopUserActivityChange, shopStatus } = this.props;
		shopUserActivityChange(status);
	}

	openMenu() {
		this.setState({ isOpen: 1 });
	}

	closeMenu() {
		this.setState({ isOpen: 0 });
	}

	renderSinglePageMenu(to, label, icon, iconLayer, isProfileMenu) {
		const { isProfileMenu: isProfileMenuState, location } = this.state;

		return (
			<li className={cx(s.listSection, isProfileMenuState === isProfileMenu && location == to ? s.active : '')}>
				<Link to={to} className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
					this.closeMenu();
				}}>
					<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
						<use xlinkHref={icon + iconLayer}></use>
					</svg>
					<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
						<span>{label}</span>
					</span>
				</Link>
			</li>
		);
	}

	renderMultiPageMenu(to, menuType, label, icon, iconLayer) {
		const { isProfileMenu, location } = this.state;

		return (
			<li className={cx(s.listSection, !isProfileMenu && this.handleMenuActive(menuType) ? s.active : '')}>
				<Link to={to} className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
					this.closeMenu();
					// isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
				}}>
					<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
						<use xlinkHref={icon + iconLayer}></use>
					</svg>
					<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
						<span>{label}</span>
					</span>
				</Link>
			</li>
		);
	}


	handleChange(e) {
		const { openHeaderModal } = this.props;
		openHeaderModal('languageModal');
	}

	render() {
		const { formatMessage } = this.props.intl;
		const { location, isProfileMenu } = this.state;
		const { shopStatus, currentLocale, shopLogout } = this.props;

		return (
			<div className={rs.restaurantSideMenuBg}>
				<div className={cx(rs.restaurantSideMenuList, 'restaurantSideMenu', 'sideMenuScroll')}>
					<Navbar expand="lg">
						<div onClick={() => this.openMenu()}>
							<div className="nav-container">
								<div className={cx("button  d-block d-md-none")} tabIndex="0">
									<span className="icon-bar"></span>
									<span className="icon-bar"></span>
									<span className="icon-bar"></span>
								</div>
							</div>
						</div>
						<div className={cx({ [rs.menuOpen]: this.state.isOpen == 1 }, rs.mobileMenu)}>
							<div className={cx({ [rs.menuClose]: this.state.isOpen == 0 }, rs.rightMenuClose, 'd-block d-md-none')}>
								<div className={cx(rs.closeColor, 'closeColorMbRTL')} onClick={() => this.closeMenu()} >
									&#10005;
								</div>
							</div>
							<Nav className="mr-auto">
								<HeaderModal />
								<ul className={s.listMainSection}>
									<li className={cx(s.listSection, s.mobileViewOnly)}>
										<div className={cx(s.sideNavitem, s.swithPadding, 'sideNavitemRTL')}>
											<span>
												<svg className={cx(s.overviewIcon, s.noBorder, s.leftIcon, s.languageIconMb)}>
													<use xlinkHref={languageIcon + '#Layer_59'}></use>
												</svg>
											</span>
											<Link noLink
												onClick={(e) => this.handleChange(e)}
												className={cx(s.siteColor, s.cursurPointer)}>
												<span className={cx(s.displayInlineBlock, s.vtrMiddle, s.iconTextPadding)}>
													{formatLocale(currentLocale)}
												</span>
											</Link>
										</div>
									</li>
									<li className={cx(s.listSection, s.mobileViewOnly)}>
										<div className={cx(s.sideNavitem, s.swithPadding, 'sideNavitemRTL')}>
											<div className={cx(s.menuHeight, 'swithMobile')}>
												<Switch
													switchOnLabel={<FormattedMessage {...messages.available} />}
													switchOffLabel={<FormattedMessage {...messages.unavailable} />}
													handleSwitch={this.handleSwitch}
													value={shopStatus}
													component={'HeaderAfterLogin'}
												/>
											</div>
										</div>
									</li>
									<li className={cx(s.listSection, !isProfileMenu && location.startsWith('/restaurant/dashboard') ? s.active : '')}>
										<Link to="/restaurant/dashboard" className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
											this.closeMenu()
											isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
										}}>
											<span>
												<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
													<use xlinkHref={dashboardIcon + '#Layer_1'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.dashboard} />
											</span>
										</Link>
									</li>
									{/* <li className={cx(s.listSection, !isProfileMenu && (location.startsWith('/restaurant/payout') || location.startsWith('/restaurant/addpayout')) ? s.active : '')}>
										<Link to="/restaurant/payout" className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
											this.closeMenu()
											isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
										}}>
											<span>
												<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
													<use xlinkHref={addPayIcon + '#Layer_4'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.addPayout} />
											</span>
										</Link>
									</li> */}
									<li className={cx(s.listSection, !isProfileMenu && location.startsWith('/restaurant/menu') ? s.active : '')}>
										<Link to="/restaurant/menu" className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
											this.closeMenu()
											isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
										}}>
											<span>
												<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
													<use xlinkHref={CategoryIcon + '#Layer_6'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.manageMenu} />
											</span>
										</Link>
									</li>
									<li className={cx(s.listSection, !isProfileMenu && location.startsWith('/restaurant/preparation-time') ? s.active : '')}>
										<Link to="/restaurant/preparation-time" className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
											this.closeMenu()
											isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
										}}>
											<span>
												<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
													<use xlinkHref={preparationTimeIcon + '#Layer_5'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.preparationTime} />
											</span>
										</Link>
									</li>
									<li className={cx(s.listSection, !isProfileMenu && location.startsWith('/restaurant/operating-hours') ? s.active : '')}>
										<Link to="/restaurant/operating-hours" className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
											this.closeMenu()
											isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
										}}>
											<span>
												<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
													<use xlinkHref={operationHoursIcon + '#Capa_1'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.operationHours} />
											</span>
										</Link>
									</li>
									<li className={cx(s.listSection, !isProfileMenu && (location.startsWith('/restaurant/order-management/') || location.startsWith('/restaurant/order-details/upcoming') || location.startsWith('/restaurant/order-details/previous')) ? s.active : '')}>
										<Link to="/restaurant/order-management/upcoming" className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
											this.closeMenu()
											isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
										}}>
											<span>
												<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
													<use xlinkHref={OrderManageIcon + '#Layer_26'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.orderManageMent} />
											</span>
										</Link>
									</li>
									<li className={cx(s.listSection, !isProfileMenu && (location.startsWith('/restaurant/transaction/') || location.startsWith('/restaurant/order-details/completed/') || location.startsWith('/restaurant/order-details/future/')) ? s.active : '')}>
										<Link to="/restaurant/transaction/completed" className={cx(s.sideNavitem, 'sideNavitemRTL')} onClick={() => {
											this.closeMenu()
											isProfileMenu && this.setState({ isProfileMenu: !isProfileMenu })
										}}>
											<span>
												<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
													<use xlinkHref={TransactionManageIcon + '#Layer_28'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.transactionManagement} />
											</span>
										</Link>
									</li>
									<li className={cx(s.listSection, this.handleMenuActive('profile') || isProfileMenu ? s.active : '')}>
										<div id='Profile' className={cx(s.sideNavitem, s.btnNoPadding)}>
											<Button
												className={cx(rs.button, s.noBorderBtn, s.activeMenu, s.sideNavitem, s.positionRelative, 'menuDropdownRTL', 'sideNavitemRTL')}
												onClick={() => { this.setState({ isProfileMenu: !isProfileMenu }); }}>
												<span>
													<svg className={cx(s.leftIcon, s.overviewIcon, s.noBorder)}>
														<use xlinkHref={editIcon + '#Layer_2'}></use>
													</svg>
												</span>
												<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
													<FormattedMessage {...messages.profile} />
												</span>
												{
													this.state.isProfileMenu &&
													<div className={cx(s.displayInlineBlock, s.downArrow, 'downArrowRTL')}>
														<HiOutlineChevronUp className={s.navigationIcon} />
													</div>
												}

												{
													!this.state.isProfileMenu && <div className={cx(s.displayInlineBlock, s.downArrow, 'downArrowRTL')}><HiOutlineChevronDown className={s.navigationIcon} /></div>
												}
											</Button>
										</div>
									</li>
									<Collapse in={isProfileMenu}>
										<ul className={cx(s.droupDownSection, 'droupDownSectionRTL')}>
											{this.renderSinglePageMenu('/restaurant/edit-profile', formatMessage(messages.editProfile), editIcon, '#Layer_2', true)}
											{this.renderSinglePageMenu('/restaurant/document', formatMessage(messages.documentUpload), DocumentUpIcon, '#Layer_3', true)}
											{this.renderSinglePageMenu('/restaurant/password', formatMessage(messages.password), passwordIcon, '#Capa_2', true)}
										</ul>
									</Collapse>
									<li className={cx(s.listSection, s.hideLogout)}>
										<Logout
											buttonClass={cx(rs.button, s.noBorderBtn, s.activeMenu, s.sideNavitem, 'sideNavitemRTL')}
											onClick={() => shopLogout()}
										>
											<span className={cx(s.overviewIcon, s.noBorder, s.leftIconCss)}>
												<svg className={s.leftIcon}>
													<use xlinkHref={LogOutIcon + '#Layer_1'}></use>
												</svg>
											</span>
											<span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
												<FormattedMessage {...messages.logout} />
											</span>
										</Logout>
									</li>
								</ul>
							</Nav>
						</div>
					</Navbar>
				</div>
			</div>
		);
	}
}

const mapState = state => ({
	shopStatus: state && state.account && state.account.data && state.account.data.isActive,
	currentLocale: state.intl.locale
});

const mapDispatch = {
	shopLogout,
	shopUserActivityChange,
	openHeaderModal
};

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(RestaurantSideMenu)));